import { useAppConfig } from './AppConfigContext';
import { GradeOption } from '../types/finderConfig';

/**
 * Finder grade options, straight from per-org settings (`/finder/config`), in
 * the admin-defined display order. No `/finder/grades` round-trip — the Finder
 * is self-contained and does not depend on the org's enrollment grades.
 */
export const useOrderedGrades = (): GradeOption[] => useAppConfig().config.gradesEnabled;
